import { EuroOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { ValueRangeRule } from '../../../../rules/repository/value-range/ValueRange.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { createCommonFormSchema } from '../common/createCommonFormSchema.ts';
import { CurrencyWidgetComponent } from './CurrencyWidgetComponent.tsx';
import {
  CurrencyWidgetConfigComponent,
  currencyInputConfigValidator,
} from './CurrencyWidgetConfigComponent.tsx';
import { type ICurrencyWidget } from './ICurrencyWidget.ts';

export const CurrencyWidgetType: IWidgetType<ICurrencyWidget> = {
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  type: WidgetType.Currency,
  name: 'Campo Valuta',
  icon: <EuroOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Number),
  formComponent: CurrencyWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(yup.string().stringCurrency().notRequired(), widget),
  previewComponent: CurrencyWidgetComponent,
  configValidator: currencyInputConfigValidator,
  configComponent: CurrencyWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [RequiredRule, ValueRangeRule, CustomWarningsRule],
};
